import RouteNames from '@/entities/RouteNames';
import RouteWrapper from '@/components/common/RouteWrapper.vue';
import { getChildRoutes } from '@/helpers/routes/getChildRoutes';
import { GetRelativeRoutes } from '@/entities/GetChildRoutes';
import Roles from '@/entities/Roles';

const onBoarding = () =>
	import('@/views/onBoarding/index.vue').then((m) => m.default);

const getOnboardingRoutes = [
	{
		path: '/onboarding',
		name: RouteNames.ONBOARDING,
		component: onBoarding,
		meta: {
			title: 'ONBOARDING',
			requiresAuth: true,
			roles: [Roles.CONTRACTOR],
			breadcrumb: {
				title: 'Onboarding',
				//   routeName: (user) => RouteNames.INVOICE,
				isStyled: true,
			},
		},
	},
];

export { getOnboardingRoutes };
